import styled from 'styled-components';
import { ReactComponent as Marker } from 'assets/icons/marker.svg';

export const IconBox = styled.div``;

export const MarkerIcon = styled(Marker)`
  width: 100%;
  height: 100%;
`;